/**
 * Сервис для работы с отчётами
 */

import axios, { AxiosRequestConfig } from 'axios';

import { pageSize } from '../constants/pagination';
import { IId } from '../models/types';
import { Moment } from 'moment';

export interface IParams {
  ListOfEmployees: IId;
  AreaId: IId;
  From: string;
  To: string;
}

export interface IGetViolationParams {
  mapId: string;
  violationType: string;
  listOfEmployees: string[];
  from: string;
  to: string;
  pageIndex: number;
}

export interface IGetNotificationParams {
  listOfEmployees: string[];
  mapId: string;
  areaId: string;
  events: string[];
  // eventTypes: string;
  from: string;
  to: string;
  pageIndex: number;
}

export interface IGetWorkingTimeParams {
  listOfEmployees: string[];
  from: string;
  to: string;
  timeDiffSeconds?: number;
  timeTableId?: string | null;
  pageIndex: number;
}

export interface IGetUseProtectionParams {
  listOfEmployees: string[];
  from: string;
  to: string;
}

export interface IGetStayInAreaParams {
  mapId: string;
  listOfAreas: string[];
  listOfEmployees: string[];
  isCollapseTransitions: boolean;
  collapseLeavesPeriodSeconds?: number;
  inAreaNow?: boolean;
  isIncludeTimeout?: boolean;
  from: string | Moment | null;
  to: string | Moment | null;
  pageIndex: number;
}

export interface IGetPhysicalStateParams {
  listOfEmployees: string[];
  physType: string;
  from: string;
  to: string;
}

export interface IGetHeatMapFilter {
  mapId: string;
  users: string[];
  from: string;
  to: string;
}

export interface IGetTracksFilter {
  users: string[];
  from: string;
  timeFrom: string;
  to: string;
  timeTo: string;
  PositionAggregationMeters: string;
  SplitByDays: boolean;
  SplitOnMapChange: boolean;
  SplitByEvents: boolean;
}

export interface IGetJSONCSVTracksFilter {
  MapId?: string;
  EmployeeId: IId;
  From: string;
  To: string;
  PositionAggregationMeters?: string;
  ReportFormat: string;
  PageIndex?: number;
  PageSize?: number;
  Total?: number;
}

const url = '/reports';

const createExportConfig = (filter: object, format: string): AxiosRequestConfig => ({
  params: { ...filter, reportFormat: format },
  responseType: 'blob'
});

const ReportService = {
  getByAreas: (params: IParams) => axios.get(`${url}/zoneReport`, { params }),
  getViolations: (params: IGetViolationParams) =>
    axios.get(`${url}/violationReport/paged`, { params: { pageSize, ...params } }),
  getViolationsTypes: () => axios.get(`${url}/violationReport/violationTypes`),
  getCsvViolations: (params: IGetViolationParams) =>
    axios.get(`${url}/violationReport`, createExportConfig(params, 'CSV')),
  getNotifications: (params: IGetNotificationParams) =>
    axios.get(`${url}/eventReport/paged`, { params: { pageSize, ...params } }),
  getCsvNotifications: (params: IGetNotificationParams) =>
    axios.get(`${url}/eventReport`, createExportConfig(params, 'CSV')),
  getNotificationEvents: () => axios.get(`${url}/eventReport/events`),
  // getNotificationEventTypes: () => axios.get(`${url}/eventReport/eventTypes`),
  getWorkingTime: (params: IGetWorkingTimeParams) =>
    axios.get(`${url}/timeReportPeriod/paged`, { params: { pageSize, ...params } }),
  getXlsxWorkingTime: (params: IGetWorkingTimeParams) =>
    axios.get(`${url}/timeReportPeriod`, createExportConfig(params, 'XLSX')),
  getUseProtection: (params: IGetUseProtectionParams) =>
    axios.get(`${url}/protectionReport/paged`, { params: { pageSize, ...params } }),
  getCsvUseProtection: (params: IGetUseProtectionParams) =>
    axios.get(`${url}/protectionReport`, createExportConfig(params, 'CSV')),
  getStayInAreas: (params: IGetStayInAreaParams) =>
    axios.get(`${url}/zoneReport/paged`, { params: { pageSize, ...params } }),
  getCsvStayInAreas: (params: IGetStayInAreaParams) =>
    axios.get(`${url}/zoneReport`, createExportConfig(params, 'CSV')),
  getPhysicalState: (params: IGetPhysicalStateParams) =>
    axios.get(`${url}/physReport/paged`, { params: { pageSize, ...params } }),
  getCsvPhysicalState: (params: IGetPhysicalStateParams) =>
    axios.get(`${url}/physReport`, createExportConfig(params, 'CSV')),
  getPhysicalStateTypes: () => axios.get(`${url}/physReport/physTypes`),
  getHeatMap: (filter: IGetHeatMapFilter) =>
    axios.get(`/fulltrack/heatMap`, {
      params: { ...filter, format: 'IMAGEMAP' },
      responseType: 'arraybuffer'
    }),
  getJsonHeatMap: (filter: IGetHeatMapFilter) =>
    axios.get(`/fulltrack/heatMap`, { params: { ...filter, format: 'RAW', scale: 'LINEAR' } }),
  getTracks: (filter: IGetTracksFilter) =>
    axios.get(`/fulltrack/tracks`, { params: { ...filter, EventTimeToleranceSeconds: 0 } }),
  getJSONCSVTracks: (params: IGetJSONCSVTracksFilter) =>
    axios.get(`${url}/trackReport`, { params, responseType: 'blob' })
};
export default ReportService;
